// extracted by mini-css-extract-plugin
export default {"bymaSwitchSelector":"BymaSwitchButton_bymaSwitchSelector__DvmHy"};